import { makeAutoObservable } from 'mobx';

class CurrentMessages {
  messagesList = [];

  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  addMessage = (newMessage) => {
    this.messagesList.push(newMessage);
  }
}

const currentMessages = new CurrentMessages();

export default currentMessages;
